module.exports = __webpack_public_path__ + "media/images/Kitchen Espresso Cabinets sq-6a05273d.jpg";